import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.425 16.042h8.75c.92 0 1.667-.746 1.667-1.667v-6.25L10.8 3.96 4.758 8.125v6.25c0 .92.747 1.667 1.667 1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.925 13.124c0-.92.746-1.666 1.666-1.666h.417c.92 0 1.667.746 1.667 1.666v2.917h-3.75v-2.917Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);